// extracted by mini-css-extract-plugin
export default {"cookiePopup":"CookiePopup_cookiePopup__f-DmM","cookieContent":"CookiePopup_cookieContent__j0Khs","buttonContainer":"CookiePopup_buttonContainer__8wLdq"};